import React from 'react'
import { FaSearch } from 'react-icons/fa'
import Image from '../Images/Package_Page/img1.png'
import Image2 from '../Images/Package_Page/img2.png'
import Image3 from '../Images/Package_Page/img3.png'
import Image4 from '../Images/Package_Page/img4.png'
import Image5 from '../Images/Package_Page/img5.png'
import Image6 from '../Images/Package_Page/img6.png'
import Image7 from '../Images/Package_Page/img7.png'
import Image8 from '../Images/Package_Page/img8.png'

function Product() {
  return (
  <>
  <div className="product--container">

  <div className="product--text">
    <h2 className='pack--tect'>Our Packages</h2>
    <FaSearch className='pack--icon' />
  </div>

  <div className="product--img--cont">
    <div className="box--img">
        <div className='pro--img'>
        <img className='product1' src={Image} alt="" />
        <p className='pro--tag'>$400 - Mobile App Design</p>
        </div>
        <div className='pro--img'>
        <img className='product2' src={Image2} alt="" />
        <p className='pro--tag'>$600 - Website Design</p>
        </div>
        <div className='pro--img'>
        <img className='product3' src={Image3} alt="" />
        <p className='pro--tag'>$200 - Product Design</p>
        </div>
        <div className='pro--img'>
        <img className='product4' src={Image4} alt="" />
        <p className='pro--tag'>$100 - Graphics Design</p>
        </div>
    </div>

    <div className="box--img2">
        <div className='pro--img'>
        <img className='product5' src={Image5} alt="" />
        <p className='pro--tag'>$1500 - Full Branding</p>
        </div>
        <div className='pro--img'>
        <img className='product6' src={Image6} alt="" />
        <p className='pro--tag'>$900 - Interaction  Design</p>
        </div>
        <div className='pro--img7'>
        <img className='product7' src={Image7} alt="" />
        <p className='pro--tag'>$750 - Interface  Design</p>
        </div>
        <div className='pro--img'>
        <img className='product8' src={Image8} alt="" />
        <p className='pro--tag'>$600 - Visual Designs</p>
        </div>
    </div>
    
  </div>

  </div>
  </>
  )
}

export default Product